import { create } from 'zustand';
import { createPaginationSlice } from './slice/paginationSlice';

export const usePaginationPBundle = create((set, get) => ({
    ...createPaginationSlice(set, get),
}));

export const usePaginationPSatuan = create((set, get) => ({
    ...createPaginationSlice(set, get),
}));
